import { ModalId } from '@heidi/schema/ml-scribe';

/** Patients GA onboarding modal IDs. */
export const PATIENT_LIST_INTRODUCTION_MODAL_ID = ModalId.PATIENT_LIST_INTRODUCTION;
export const PATIENT_LIST_NAV_SPOTLIGHT_MODAL_ID = ModalId.PATIENT_LIST_NAV_SPOTLIGHT;
